
import XTable from 'vux/src/components/x-table/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import Vue from 'vue'

var DetailFileCom = Vue.extend({})

Vue.component('detail-file', DetailFileCom)

export default {
name: 'DetailFile',
props: ['fileData','fileList'],
components: {
XTable,
XButton
},
data () {
return {
baseUrl: this.$store.state.url,
fileUrl: '',// 附件-文件地址（供复制）
}
},
mounted () {
},
methods: {
showFile (index,url,type,fileName){// 查看附件
this.fileUrl = '';
let typeStr = type.toLowerCase().slice(-3);
if(typeStr==='jpg'||typeStr==='png'||typeStr==='gif'||typeStr==='peg'){// 图片

let imgLinkArr = [];
let imgArr = this.fileList;
let imgLink;
for(var i in imgArr){
imgLinkArr.push(imgArr[i].src);
}
imgLink = imgLinkArr[index];

this.$vux.loading.show({
text: '加载中'
});
this.axios({
url: this.baseUrl + imgLink,
method: 'get',
}).then((response) => {
this.$vux.loading.hide();
let showImg = this.baseUrl + '/' + response.data.filePath;
let showImgArr = [];

showImgArr.push(showImg);
setTimeout(() => {
wx.previewImage({
current: showImg, // 当前显示图片的http链接
urls: showImgArr 
});
}, 500);

}).catch((response) => {
this.$vux.loading.hide();
});

}else{// 文档

let fileLinkArr = [];
let fileArr = this.fileList;
let fileLink;
let loadFile;
for(var i in fileArr){
fileLinkArr.push(fileArr[i].src);
}
fileLink = fileLinkArr[index];

this.$vux.loading.show({
text: '加载中'
});
this.axios({
url: this.baseUrl + fileLink,
method: 'get',
}).then((response) => {
this.$vux.loading.hide();
loadFile = this.baseUrl + '/' + response.data.filePath;
this.fileUrl = loadFile;
this.$router.push({
path: '/seefile',
query:{
loadFile:this.fileUrl,
fileName:fileName
}
});

}).catch((response) => {
this.$vux.loading.hide();
});

}

}
}
}



// WEBPACK FOOTER //
// ./src/components/detail/File.vue